import { useContext } from 'react'
import { InstallationsContextProps } from '../types'
import { InstallationsContext } from '../context/installations-context'

/**
 * provides notification context if used inside the notification provider
 */
const useInstallationsContext = (): InstallationsContextProps => {
  const installationsContext = useContext(InstallationsContext)

  if (installationsContext === undefined) {
    throw new Error('installations context is used outside of its provider')
  }

  return installationsContext
}

export default useInstallationsContext
